import { EditableText, defineBlock } from "eddev/blocks"
import { Marquee } from "@components/atoms/Marquee"
import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { twMerge } from "tailwind-merge"
import DiamondLatticeBackground from "@components/atoms/DiamondLattice"
import { Link } from "eddev/routing"
import { Button } from "@components/atoms/Button"
import * as Icons from "@components/atoms/Icons"

export const meta: BlockMeta = {
  title: "Road Safety Research Entry",
  category: "common",
  icon: "car",
  tags: ["root"],
  editMode: "preview",
  conditions: {
    postTypes: ["page", "post"],
    multiple: false,
  },
}

export default defineBlock("home/research-hub-entry", (props) => {
  return (
    <div className="w-full md:w-[calc(var(--tw-grid-inner-width)+(var(--spacing-6)*2))] mx-auto bg-yellow md:rounded-lg relative overflow-hidden flex flex-col gap-2 z-0 my-6">
      <div className="grid-auto relative gap-6 z-10 py-6 md:p-6">
        <div className="col-span-12 flex flex-col gap-2 text-center">
          <EditableText as="span" store="subtitle" placeholder="Enter subtitle..." className="!type-label-caps" />
          <EditableText as="h4" store="title" placeholder="Enter title..." className="!type-title-m" />
        </div>

        {props.links?.map((item, i) => (
          <div key={i} className="col-span-12 md:col-span-4">
            <Link
              href={item?.link?.url}
              className="relative w-full flex flex-col box-border p-4 bg-white rounded-md hover:md:-translate-y-[12px] hover:z-20 group aaa-animate !duration-300"
            >
              <h4 className="flex type-title-s !text-center w-full !mb-4">{item?.title}</h4>
              {item?.image && (
                <ResponsiveImage
                  {...item.image}
                  objectFit="cover"
                  className="aspect-video overflow-hidden rounded-sm w-full"
                />
              )}

              <div className="md:absolute md:-mt-4 md:-ml-4 w-full md:top-full h-0 overflow-hidden bg-white rounded-b-md group-hover:h-[calc(32px+(var(--spacing-4)*1))] group-hover:md:h-[calc(32px+(var(--spacing-4)*2))] aaa-animate !duration-300">
                <div className="pt-4 md:p-4 w-full">
                  <button className="w-full flex items-center text-black justify-between bg-yellow rounded-sm type-label-m h-[32px] px-2 box-border">
                    <span>{item?.buttonText}</span>
                    {Icons["ARROW_RIGHT"]}
                  </button>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-12 w-full relative gap-2 z-10">
        {props.sponsors && props.sponsors.length > 0 && (
          <div className="col-span-12">
            <div className="flex flex-col gap-4 items-center justify-center relative z-10">
              <Marquee>
                {props.sponsors.map((logo, i) => (
                  <div
                    key={i}
                    className={twMerge(
                      "w-[120px] h-[120px] flex box-content items-center justify-center px-6",
                      "[&>div]:w-full [&>div]:bg-transparent",
                    )}
                  >
                    <ResponsiveImage {...logo?.logo} />
                  </div>
                ))}
              </Marquee>
              <EditableText
                as="span"
                className="type-label-caps px-6 w-full text-center"
                store="marquee"
                placeholder="Enter text..."
              />
            </div>
          </div>
        )}
      </div>

      <div className="grid-auto relative gap-6 z-10 py-6 md:p-6">
        <div className="col-span-12 p-6 bg-black rounded-lg">
          <div className="grid grid-cols-12 w-full gap-6">
            <div className="col-span-12 md:col-span-3">
              <EditableText
                as="span"
                className="block type-title-l md:type-title-s text-white w-full text-center md:text-left"
                store="banner1"
                placeholder="Enter text..."
              />
            </div>
            <div className="col-span-12 md:col-span-4 md:col-start-5">
              <EditableText
                as="span"
                className="block type-body-m text-white w-full text-center md:text-left"
                store="banner2"
                placeholder="Enter text..."
              />
            </div>
            <div className="col-span-12 md:col-span-3 md:col-start-10">
              {props.bannerLink?.url && (
                <Button
                  color="yellow"
                  size="medium"
                  icon={props.bannerLink?.target ? "ARROW_UP_RIGHT" : "ARROW_RIGHT"}
                  iconStyle="right"
                  href={props.bannerLink.url}
                  target={props.bannerLink?.target ? "_blank" : undefined}
                >
                  {props.bannerLink?.title}
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="absolute z-0 top-[50%] left-0 w-full h-[300px]">
        <DiamondLatticeBackground />
      </div>
    </div>
  )
})
